/// <amd-module name="Feed/Legacy/Components/Settings/IdentityPickerWrapper" />
import * as React from "react";

import { Label } from "OfficeFabric/Label";

import { TimerManagement } from "VSS/Core/TimerManagement";
import { PeoplePickerProvider } from "VSS/Features/Identities/IdentityPickerProvider";
import { IdentitiesSearchRequestModel, IIdentity } from "VSS/Features/Identities/IdentityService";
import { IVssPageContext } from "VSS/Platform/Context";

import { IPeoplePickerProvider, PeoplePickerDropdown } from "VSSUI/PeoplePicker";

import * as PackageResources from "Feed/Common/Resources";

// Dropdown height should contain within dialog's height
const displayedListItemCount: number = 5;

export interface IIdentityPickerDropdownOptions {
    pageContext: IVssPageContext;

    // tslint:disable-next-line:no-any
    onIdentitiesResolved: (identities: IIdentity[]) => void;

    /**
     * When true, search and dropdown controls should handle multiple identities
     * In New webplatform, PeoplePicker doesn't have onChange,
     * so using PeoplePickerDropdown which supports only 1 identity at a time
     */
    multiIdentitySearch: boolean;
}

export class IdentityPickerWrapper extends React.PureComponent<IIdentityPickerDropdownOptions> {
    private pickerProvider: IPeoplePickerProvider;
    private timerManagement: TimerManagement;

    constructor(props: IIdentityPickerDropdownOptions) {
        super(props);

        this.pickerProvider = new PeoplePickerProvider(this.props.pageContext, {
            autoFocus: true,
            identityTypes: ["user", "group"],
            operationScopes: ["ims"],
            options: {
                MinResults: displayedListItemCount,
                MaxResults: displayedListItemCount
            }
        } as Partial<IdentitiesSearchRequestModel>);

        this.timerManagement = new TimerManagement();
    }

    public render(): JSX.Element {
        return (
            <div className="feed-identity-picker-wrapper">
                <Label>{PackageResources.FeedSettings_AddPermission_IdentityPicker_Label}</Label>
                <PeoplePickerDropdown
                    className="feed-identity-picker-dropdown"
                    suggestionsItemClassName="suggestionss"
                    pickerProvider={this.pickerProvider}
                    onChange={(identity?: IIdentity) => {
                        this.timerManagement.setImmediate(() => {
                            if (identity != null) {
                                this.props.onIdentitiesResolved([identity]);
                            } else {
                                // only 1 identity existed before and it is removed now
                                this.props.onIdentitiesResolved(null);
                            }
                        });
                    }}
                />
            </div>
        );
    }
}
